export enum FileUploadedState {
  Completed = 'completed',
  Faulty = 'faulty',
}

export interface IFileUploaded extends File {
  id?: string;
  state?: FileUploadedState;
}
